import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

import theme from '../theme';

const {
  colors: { cellSubTextColor },
} = theme;

const TableCellSubText = ({ children, className }) => {
  const { classes, cx } = useStyles(styles);
  return (
    <div className={cx(classes.tableCellSubText, className)}>{children}</div>
  );
};

const styles = ({ fontSizes }) => ({
  tableCellSubText: {
    '@media only screen and (max-width:1920px)': {fontSize: '13.5000px'},
'@media only screen and (max-width:1600px)': {fontSize: '10px'},

    color: cellSubTextColor,
    fontWeight: 400,
  },
});

TableCellSubText.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default TableCellSubText;
